<h2 mat-dialog-title>Import Voice Macros</h2>

<mat-dialog-content class="mat-typography">

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Data</mat-label>
			<textarea class="import-area" matInput cdkFocusInitial [(ngModel)]="data" ></textarea>
		</mat-form-field>
	</div>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close >cancel</button>
	<button mat-button [mat-dialog-close]="voiceMacros" [disabled]="!data?.trim().length">import</button>
</mat-dialog-actions>
